import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    maxSize: { type: Number, default: 10 * 1024 * 1024 }, // 10MB
    allowedTypes: { type: Array, default: ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'] }
  }

  validateFile(event) {
    const file = event.target.files[0]
    if (!file) return

    // Check file size
    if (file.size > this.maxSizeValue) {
      this.showError(`File size must be less than ${this.formatFileSize(this.maxSizeValue)}`)
      this.clearFile()
      return
    }

    // Check file type
    if (!this.allowedTypesValue.includes(file.type)) {
      this.showError('File must be a CSV or Excel file')
      this.clearFile()
      return
    }

    // Clear any existing error messages
    this.clearError()
  }

  showError(message) {
    this.clearError()
    const errorDiv = document.createElement('div')
    errorDiv.className = 'invalid-feedback'
    errorDiv.textContent = message
    this.element.parentNode.appendChild(errorDiv)
    this.element.classList.add('is-invalid')
  }

  clearError() {
    const errorDiv = this.element.parentNode.querySelector('.invalid-feedback')
    if (errorDiv) {
      errorDiv.remove()
    }
    this.element.classList.remove('is-invalid')
  }

  clearFile() {
    this.element.value = ''
  }

  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }
}
